// 视频
(function () {
    height();
    $(window).resize(height);

    function height() {
        $(".banner").height($(window).height());
    }

    $(".downIcon img").click(function () {
        var top = $(window).height();
        $("body,html").animate({
            scrollTop: top
        }, 500);
    });

})();


// 图片放大

(function () {
    scalePicture();
    $(window).resize(scalePicture);

    function scalePicture() {
        // 首页上千种任务
        var widthScale = $(window).width() / 800;
        var newHeight = widthScale * 680;
        if (widthScale > 1) {
            $('.picture').css("transform", "scale(" + widthScale + ")");
            var marginTop = (newHeight - 680) / 2 + 200;
            $('.picture').css("margin", "" + marginTop + "px auto");

        } else {
            var marginLeft = ($(window).width() - 800) / 2;
            var marginTop = (680 - newHeight) / 2 + 100;
            $('.picture').css("transform", "scale(" + widthScale + ")");
            $('.picture').css("margin-left", "" + marginLeft + "px");
            $('.picture').css("margin-bottom", "" + marginTop + "px");
            $('.picture').css("margin-top", "" + marginTop + "px");
        }

        // 首页安全措施
        var widthScale1 = $(window).width() / 940;
        var newHeight1 = widthScale * 944;
        if (widthScale1 < 1) {
            $('.safeContent ul').css("transform", "scale(" + widthScale1 + ")");
            var marginLeft1 = ($(window).width() - 940) / 2;
            var marginTop1 = -(944 - newHeight1) / 2;
            $('.safeContent ul').css("margin-left", "" + marginLeft1 + "px");
            $('.safeContent ul').css("margin-top", "" + marginTop1 + "px");
        }
    }
})();

/*导航栏*/

$(function () {
    $(".openIcon").click(function () {
        $(".smallNav").slideDown();
        $(".closeIcon").show();
        $(".openIcon").css("opacity", 0);
        $('.swiper-container').css('pointer-events', 'none');
        $('.swiper-container').css('height', $(window).height() + 'px');
    });
    $(".closeIcon").click(function () {
        $(".smallNav").slideUp();
        $(".closeIcon").hide();
        $(".openIcon").css("opacity", 1);
        $('.swiper-container').css('pointer-events', 'all');
        $('.swiper-container').css('height', 'auto');
    });

});

// 关于我们页面
$(function () {
    var $timeline_block = $('.cd-timeline-block');
    //hide timeline blocks which are outside the viewport
    $timeline_block.each(function () {
        if ($(this).offset().top > $(window).scrollTop() + $(window).height() * 0.75) {
            $(this).find('.cd-timeline-img, .cd-timeline-content').addClass('is-hidden');
        }
    });
    //on scolling, show/animate timeline blocks when enter the viewport
    $(window).on('scroll', function () {
        $timeline_block.each(function () {
            if ($(this).offset().top <= $(window).scrollTop() + $(window).height() * 0.75 && $(this).find('.cd-timeline-img').hasClass('is-hidden')) {
                $(this).find('.cd-timeline-img, .cd-timeline-content').removeClass('is-hidden').addClass('bounce-in');
            }
        });
    });
});


// 关于我们视频

$(function () {
    if ($(window).width() > 1225) {
        $('.about-video img').click(function () {
            $('.about-video').html(' <iframe class="videoIframe"  frameborder="0" scrolling="no" height="523" width="1052" src="https://v.qq.com/iframe/preview.html?width=1052&height=523&auto=1&vid=p08435tdeo6" allowfullscreen></iframe>');

        });
    } else if (($(window).width() == 1225 || $(window).width() < 1225) && $(window).width() > 768) {
        $('.about-video img').click(function () {
            $('.about-video').html(' <iframe class="videoIframe"  frameborder="0" scrolling="no" height="523" width="768" src="https://v.qq.com/iframe/preview.html?width=768&height=523&auto=1&vid=p08435tdeo6" allowfullscreen></iframe>');

        });
    } else {
        $('.about-video img').click(function () {
            $('.about-video').html(' <iframe class="videoIframe"  frameborder="0" scrolling="no" height="180" width="345" src="https://v.qq.com/iframe/preview.html?width=345&height=180&auto=1&vid=p08435tdeo6" allowfullscreen></iframe>');

        });
    }


});

//右下角工具
(function () {
    $(".back2top").on('click', function () {
        $("html, body").animate({
            scrollTop: 0
        }, 800);
    });
    $(".qrcode").hover(function () {
        $(".tools_code_box").toggle();
    });
    if ($(window).width() > 768) {
        $(window).on("scroll", function () {
            if ($(window).scrollTop() > $(window).height())
                $(".tools").fadeIn();
            else
                $(".tools").fadeOut();
        })
    }

})();
